import React, { useEffect, useState } from "react";
import axios from "axios";
import { Building2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const B2BChatTip = ({ task }) => {
  const [details, setDetails] = useState(null);

  useEffect(() => {
    if (!task?.is_b2b || !task?.id) return;
    axios.get(`${API}/b2b/tasks/${task.id}/details`).then(r => setDetails(r.data)).catch(() => setDetails(null));
  }, [task?.id, task?.is_b2b]);

  if (!task?.is_b2b) return null;
  return (
    <div
      className="px-4 py-2 text-xs flex items-start gap-2"
      data-testid="b2b-chat-tip"
      style={{ background: "#F0F9FF", borderBottom: "1px solid #7DD3FC", color: "#0C4A6E" }}
    >
      <Building2 size={14} className="flex-shrink-0 mt-0.5" />
      <span>
        <strong>Заказчик — организация{details?.org_name ? ` (${details.org_name})` : ""}.</strong>{" "}
        Оплата напрямую по реквизитам исполнителя (счёт из «Мой налог» или ИП). Реквизиты и согласование — здесь в чате.
        После выполнения исполнитель выдаёт заказчику чек.
      </span>
    </div>
  );
};
